import { BoxProps, Box, Column, MotionPath } from "@hightouch/htui";
import { getTraceVariants } from "./utils";
import { SIZES } from "src/ui/box";

/**
 * Loader animation for area graphs.
 * "roller coaster" effect with a gradient below the line area.
 */
export const AreaGraphLoader = (props: BoxProps) => {
  const traceVariants = getTraceVariants();

  return (
    <Column
      align="center"
      justify="center"
      boxSize="100%"
      maxH="100%"
      {...props}
    >
      <Box
        as="svg"
        width="100%"
        height="auto"
        viewBox="0 0 736 184"
        fill="none"
        maxW={SIZES.graphLoader}
        mx="auto"
      >
        <defs>
          <mask id="areaFadeMask">
            <rect width="100%" height="100%" fill="url(#areaFadeGradient)" />
          </mask>
          <linearGradient
            id="areaFadeGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="white" stopOpacity="0" />
            <stop offset="15%" stopColor="white" stopOpacity="1" />
            <stop offset="85%" stopColor="white" stopOpacity="1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <linearGradient
            id="paint0_linear_4918_30825"
            x1="364.5"
            y1="0"
            x2="364.5"
            y2="162"
            gradientUnits="userSpaceOnUse"
          >
            {/* not casting color correctly here so using var */}
            <stop stopColor="var(--chakra-colors-gray-200)" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
          <radialGradient
            id="paint1_radial_4918_30825"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(14.8233 147.797) rotate(90) scale(41.3088 61.2813)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>

        <g mask="url(#areaFadeMask)">
          <Box
            as="path"
            d="M-7 162L114.108 113.223C115.446 112.684 116.869 112.391 118.31 112.357L180.685 110.894C184.42 110.806 187.901 108.984 190.101 105.965L220.103 64.7993C221.812 62.455 224.312 60.8089 227.141 60.1658L322.903 38.3938C323.993 38.1461 325.042 37.7475 326.021 37.2095L386.98 3.71652C391.1 1.45274 396.163 1.80337 399.932 4.61352L480.951 65.0244C481.927 65.7521 483.008 66.3271 484.157 66.7296L517.248 78.3204C520.601 79.4948 524.302 79.1231 527.355 77.3053L565.376 54.6634C568.159 53.0062 571.494 52.5443 574.622 53.3827L661.513 76.6669C664.002 77.3338 666.639 77.1819 669.035 76.2338L736 49.7319"
            stroke="gray.100"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M114.108 113.223L-7 162H732C734.209 162 736 160.209 736 158V49.7319L669.035 76.2338C666.639 77.1819 664.002 77.3338 661.513 76.6669L574.622 53.3827C571.494 52.5443 568.159 53.0062 565.376 54.6634L527.355 77.3053C524.302 79.1231 520.601 79.4948 517.248 78.3204L484.157 66.7296C483.008 66.3271 481.927 65.7521 480.951 65.0244L399.932 4.61352C396.163 1.80337 391.1 1.45274 386.98 3.71652L326.021 37.2095C325.042 37.7475 323.993 38.1461 322.903 38.3938L227.141 60.1658C224.312 60.8089 221.812 62.455 220.103 64.7993L190.101 105.965C187.901 108.984 184.42 110.806 180.685 110.894L118.31 112.357C116.869 112.391 115.446 112.684 114.108 113.223Z"
            fill="url(#paint0_linear_4918_30825)"
          />
          <MotionPath
            d="M-7 162L114.108 113.223C115.446 112.684 116.869 112.391 118.31 112.357L180.685 110.894C184.42 110.806 187.901 108.984 190.101 105.965L220.103 64.7993C221.812 62.455 224.312 60.8089 227.141 60.1658L322.903 38.3938C323.993 38.1461 325.042 37.7475 326.021 37.2095L386.98 3.71652C391.1 1.45274 396.163 1.80337 399.932 4.61352L480.951 65.0244C481.927 65.7521 483.008 66.3271 484.157 66.7296L517.248 78.3204C520.601 79.4948 524.302 79.1231 527.355 77.3053L565.376 54.6634C568.159 53.0062 571.494 52.5443 574.622 53.3827L661.513 76.6669C664.002 77.3338 666.639 77.1819 669.035 76.2338L736 49.7319"
            stroke="gray.300"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            variants={traceVariants}
            initial="initial"
            animate="animate"
          />
        </g>
      </Box>
    </Column>
  );
};
